import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'home-driver-training',
    templateUrl: './home-driver-training.component.html',
    styleUrls: ['./home-driver-training.component.scss'],
    providers: [MessageService]
})
export class HomeDriverTrainingComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {
    }
}
